import React, { useEffect, useState } from "react";
import Table from "react-bootstrap/Table";
import "bootstrap/dist/css/bootstrap.min.css";

const TabellaAnomalie = () => {
  const [anomalie, setAnomalie] = useState([]);
  const [loading, setLoading] = useState(true);
  // Stato per l'ordinamento
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

  useEffect(() => {
    fetch("./ordini_urgenti.json")
      .then((res) => res.json())
      .then((data) => {
        const arrayAnomalie = data?.ANOMALIE || [];
        setAnomalie(arrayAnomalie.flat());
        setLoading(false);
      })
      .catch((err) => {
        console.error("Errore fetch:", err);
        setLoading(false);
      });
  }, []);

  // Funzione di ordinamento
  const requestSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });

    const sortedData = [...anomalie].sort((a, b) => {
      if (a[key] < b[key]) return direction === 'asc' ? -1 : 1;
      if (a[key] > b[key]) return direction === 'asc' ? 1 : -1;
      return 0;
    });
    setAnomalie(sortedData);
  };

  const formatData = (dateStr) => {
    if (!dateStr) return "-";
    const soloData = dateStr.split(" ")[0];
    return soloData.split("-").reverse().join("/");
  };

  // Controllo 3 giorni per riga rosa
  const isOld = (dateStr) => {
    if (!dateStr) return false;
    const dataRimesso = new Date(dateStr.split(" ")[0]);
    const oggi = new Date();
    const diffTime = oggi - dataRimesso;
    const diffDays = diffTime / (1000 * 60 * 60 * 24);
    return diffDays > 3;
  };

  return (
    <div
      className="bg-dark text-light widget-client2 ombra tb"
      style={{ 
        borderRadius: "10px", 
        border: "1px solid #c2c2c2",
        position: "relative",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div className="mt-2 text-center">
        <span className="text-title">ANOMALIE</span>
      </div>

      <style>{`
        .hide-scrollbar::-webkit-scrollbar { display: none; }
        .hide-scrollbar { scrollbar-width: none; -ms-overflow-style: none; }

        .table-anomalie { 
          color: #eee !important; 
          margin-bottom: 0; 
          border-collapse: separate; /* Obbligatorio per sticky */
          border-spacing: 0;
        }
        
        .table-anomalie thead th {
          position: sticky;
          top: 0;
          z-index: 10;
          background-color: #222 !important;
          color: #ffffff;
          font-size: 0.7rem;
          text-transform: uppercase;
          cursor: pointer;
        }

        /* Colore riga rosa (più di 3 giorni) */
        .riga-ritardo {
          background-color: #632a3d !important; 
          color: #ffb3c1 !important;
        }

        .marquee-container {
          max-width: 100px;
          overflow: hidden;
          white-space: nowrap;
          cursor: help;
        }

        .marquee-text {
          display: inline-block;
          transition: transform 2s ease-in-out;
        }

        .marquee-container:hover .marquee-text {
          transform: translateX(calc(-100% + 100px));
        }

        .table-anomalie td {
          border-color: #dbdbdb;
          vertical-align: middle;
          font-size: 0.75rem;
        }
      `}</style>

      <div className="hide-scrollbar" style={{ maxHeight: "400px", overflowY: "auto" }}>
        <Table hover className="table-anomalie" variant="light">
          <thead>
            <tr>
              <th>Causale</th>
              <th onClick={() => requestSort('codice_fornitore')}>Cod. Forn.</th>
              <th>Ragione Sociale</th>
              <th onClick={() => requestSort('data_rimesso')}>Data Rimesso</th>
              <th>Num. Rimesso</th>
              <th>Dep.</th>
              <th onClick={() => requestSort('id_bem')}>ID BEM</th>
              <th>Prec.</th>
              <th>Articolo</th>
              <th>Qta</th>
              <th onClick={() => requestSort('data_completamento_bem')}>Compl. BEM</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan="11" className="text-center py-4">Caricamento...</td></tr>
            ) : (
              anomalie.map((item, index) => {
                const ritardo = isOld(item.data_rimesso);
                return (
                  <tr key={index} className={ritardo ? "riga-ritardo" : ""}>
                    <td className={ritardo ? "" : "text-secondary"}>{item.causale}</td>
                    <td className={ritardo ? "" : "text-secondary"}>{item.codice_fornitore}</td>
                    <td>
                      <div className="marquee-container">
                        <span className="marquee-text fw-bold">{item.ragione_sociale}</span>
                      </div>
                    </td>
                    <td>{formatData(item.data_rimesso)}</td>
                    <td>{item.numero_rimesso?.replace(/,$/, "")}</td>
                    <td>{item.deposito}</td>
                    <td>{item.id_bem}</td>
                    <td>{item.precodice}</td>
                    <td>{item.articolo}</td>
                    <td className="text-center fw-bold">{parseFloat(item.quantita).toFixed(0)}</td>
                    <td>{formatData(item.data_completamento_bem)}</td>
                  </tr>
                );
              })
            )}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default TabellaAnomalie;